import { useCookieValue } from '../../hooks/useCookieValue'

const DISMISS_LAUNCH_LAPTOP_HELPER_COOKIE = 'dismiss_launch_laptop_helper'
const DISMISS_COOKIE_VALUE = 'true'

export const useLaunchLaptopHelperDismissed = (): boolean =>
  useCookieValue(DISMISS_LAUNCH_LAPTOP_HELPER_COOKIE) === DISMISS_COOKIE_VALUE

export const setLaunchLaptopHelperDismissed = (): void => {
  if (typeof document === 'undefined') {
    return
  }

  document.cookie = `${DISMISS_LAUNCH_LAPTOP_HELPER_COOKIE}=${DISMISS_COOKIE_VALUE}; Path=/; SameSite=Lax`
}
